
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import CreateEditAddonDialog from "../dialogs/create-edit-addon-dialog.vue";
import MenuCreateAddon from "./menu-create-addon.vue";
import CurrencyConverter from "../common/currency-converter.vue";
import ConfirmationDialog from "../dialogs/confirmation-dialog.vue";
import MenuUploadAddonsEmpty from "./menu-upload-addons-empty.vue";

export default {
  components: {
    MenuCreateAddon,
    CreateEditAddonDialog,
    CurrencyConverter,
    ConfirmationDialog,
    MenuUploadAddonsEmpty
  },
  data() {
    return {
      showAddNewAddonDialog: false,
      allPhotos: [],
      selectedItems: [],
      selectedAddon: {},
      showDeleteConfirmationDialog: false,
      deleteLoading: false
    };
  },
  computed: {
    ...mapState("menu", ["addons"]),
    sortedAddons() {
      return this.addons.slice().sort((a, b) => a.id - b.id);
    }
  },

  methods: {
    ...mapActions("menu", ["getAddons", "deleteAddon"]),
    ...mapMutations("menu", ["DELETE_ADDON"]),
    async handleDeleteAddon() {
      this.deleteLoading = true;
      try {
        await this.deleteAddon(this.selectedAddon.id);
        await this.getAddons(true);
        this.$nuxt.$emit("show-toast", {
          text: "Add-on removed successfully",
          color: "success darken-2",
          icon: "done",
          flat: true
        });
        this.DELETE_ADDON(this.selectedAddon.id);
      } catch (err) {
        this.$nuxt.$emit("show-error-toast", err);
      }
      this.deleteLoading = false;
      this.selectedAddon = null;
      this.showDeleteConfirmationDialog = false;
    },
    openBulkUpload() {
      this.showAddNewAddonDialog = true;
    },

    editAddon(addon) {
      this.selectedAddon = addon;
      this.showAddNewAddonDialog = true;
    },
    deleteSelectedAddon(addon) {
      this.selectedAddon = addon;
      this.showDeleteConfirmationDialog = true;
    }
  }
};
